import { render } from "./IOPmedicalPrintDetail.vue?vue&type=template&id=9892e200"
import script from "./IOPmedicalPrintDetail.vue?vue&type=script&lang=js"
export * from "./IOPmedicalPrintDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__